import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BreadCrumb, Header, Tag } from 'qw-ui-lib-v2';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from '../../locale';
import TheatreGroupDetailsHeader from '../../components/groups/TheatreGroupDetailsHeader';
import TheatreGroupDetailsTable from '../../components/groups/TheatreGroupDetailsTable';
import './GroupDetail.scss';
import bindDispatch from '../../common/util/redux';
import { useCompanyIdFromUrl } from '../../hooks/useCompanyIdFromUrl';

const GroupDetailsAdmin = ({
  groups: {
    loading,
    groupDetail: { groupName, theatres, updatedOn, updatedBy, error },
  },
  actions: { fetchTheatresInGroupForAdmin },
}) => {
  const { groupId } = useParams();
  const companyId = useCompanyIdFromUrl();

  useEffect(() => {
    fetchTheatresInGroupForAdmin(groupId);
  }, [fetchTheatresInGroupForAdmin, groupId]);

  const navigate = useNavigate();

  return (
    <>
      <div className="group-detail-page">
        <BreadCrumb
          isLoading={loading}
          links={[
            {
              name: I18n.t('theatreGroups'),
              path: `/admin/${companyId}/groups`,
            },
            { name: groupName },
          ]}
          handleRedirect={navigate}
        />
        <Header
          name={groupName}
          withShadow={false}
          customBadge={
            !loading &&
            theatres.length > 0 && (
              <Tag
                className="ml1 qw-medium"
                size="lg"
                style={{ lineHeight: '1.25rem' }}
              >
                {I18n.t('countTheatres', {
                  count: theatres.length,
                })}
              </Tag>
            )
          }
        />
        <div className="full-layout group-detail-page__content">
          <TheatreGroupDetailsHeader
            name={groupName}
            theatreCount={theatres.length}
            updatedOn={updatedOn}
            updatedBy={updatedBy}
            isLoading={loading}
          />
          <TheatreGroupDetailsTable
            data={theatres}
            isLoading={loading}
            isError={error}
          />
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    groups: state.groups,
  };
}

GroupDetailsAdmin.propTypes = {
  groups: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, bindDispatch)(GroupDetailsAdmin);
